import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDrawer } from '../../../shared/drawer';
import { useStore } from '../../../shared/store';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { CentrosForm } from './centros-form';


export const Centros = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);




    const handleNewAction = () => {
        open('centro.button.new', <CentrosForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.centros'}
            newActionTitle={'centro.button.new'}
        >
            <>
                <Table
                    path="/fleet/centers/"
                    deletePath="/fleet/centers/"
                    callBeforeDrawerClosed={handleClose}
                    Form={CentrosForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.form-label.name'
                        },
                        {
                            key: 'country',
                            subKey: 'name',
                            label: 'common.label.country'
                        },
                        {
                            key: 'city',
                            label: 'common.form-label.ciudad'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};